document.addEventListener('DOMContentLoaded', () => {

  const btn = document.getElementById('TFDThemeToggle');

  if (!btn) return;

  const icon =
    btn.querySelector('.tfd-navbar-theme-icon');

  const savedTheme =
    localStorage.getItem('tfd-theme');

  if (savedTheme) {
    document.documentElement.setAttribute(
      'data-theme',
      savedTheme
    );
  }

  updateIcon();

  btn.addEventListener('click', () => {

    const current =
      document.documentElement.getAttribute(
        'data-theme'
      );

    const next =
      current === 'dark'
        ? 'light'
        : 'dark';

    document.documentElement.setAttribute(
      'data-theme',
      next
    );

    localStorage.setItem(
      'tfd-theme',
      next
    );

    updateIcon();

  });

  function updateIcon(){

    if (!icon) return;

    const current =
      document.documentElement.getAttribute(
        'data-theme'
      );

    icon.textContent =
      current === 'dark'
          ? '☀'
        : '🌙';

  }

});